<!-- main top header -->
<header>
    <nav class="navbar">
        <a class="">
            <img src="assets/icons/brand_logo.png" alt="brand" width="50">
        </a>
        <a class="">
            <img src="assets/icons/logo.png" alt="logo" width="184">
        </a>
        <a class="" (click)="toggleNavbar()">
            <img src="assets/icons/btn_menu.png" alt="menu" width="40">
        </a>
        <div class="sidenav" [ngClass]="{ 'show': navbarOpen }">
            <a href="javascript:void(0)" class="closebtn" (click)="closeNavbar()">&times;</a>
            <a [routerLink]="['/home']" routerLinkActive="active" (click)="closeNavbar()">Home</a>
            <a [routerLink]="['/how-to-play']" routerLinkActive="active" (click)="closeNavbar()">How to Play</a>
            <a [routerLink]="['/faqs']" routerLinkActive="active" (click)="closeNavbar()">Faq</a>
            <a [routerLink]="['/terms-conditions']" routerLinkActive="active" (click)="closeNavbar()">Terms &
                Conditions</a>
        </div>
        <div class="overlay" [ngClass]="{ 'show': navbarOpen }" (click)="closeNavbar()"></div>
    </nav>
</header>
<!-- ./end main top header -->
<!-- ./end success model -->
<router-outlet></router-outlet>